module.exports = __webpack_public_path__ + "img/lucky7daily_icon.27e1be02.png";